export default __webpack_public_path__ + "static/media/fa-solid-900.3e2bc2ff.svg";